import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import { FormattedMessage } from "react-intl";

export default function EditNameDialog({
  toggle,
  isOpen,
  title,
  onChange,
  defaultName,
  onProceed,
}) {
  return (
    <Modal size="md" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <Label for="name">
          <FormattedMessage id="Name" />:
        </Label>
        <Input
          name="name"
          type="text"
          value={defaultName ?? ""}
          onChange={(data) => onChange(data.target.value)}
        ></Input>
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => toggle()} outline color="secondary">
          <FormattedMessage id="Cancel" />
        </Button>
        <Button onClick={() => onProceed()} outline color="primary">
          <FormattedMessage id="Save" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
